import { pushTo } from '@app/core/routing';
import { useAvailableSocialExportSources } from '@app/modules/fragments/hooks/useAvailableSocialExportSources';
import { routeGenerator } from '@app/modules/fragments/routing/FragmentsRoutes';
import { useFragment } from '@app/modules/fragments/screens/view/hooks/useFragment';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { useAvailableSocialExportPlatformsForStation } from '@app/modules/social-export/hooks/useAvailableSocialExportPlatformsForStation';
import { usePublishRestrictions } from '@app/modules/social-export/hooks/usePublishRestriction';
import { SocialExportPublishPlatformDropdown } from '@app/modules/social-export/publish';
import { webApi } from '@mi-front/api-clients';

interface SocialExportPublishDropdownProps {
  uploadsByPlatform: Map<string, webApi.FragmentSocialUploadItemDto[]> | undefined;
}

/**
 * "Publicar en" menu for fragments; navigates to the fragment upload screen for the chosen platform.
 */
export function SocialExportPublishDropdown({
  uploadsByPlatform,
}: SocialExportPublishDropdownProps) {
  const { fragment, durationMs } = useFragment();
  const { platforms: availablePlatforms } =
    useAvailableSocialExportPlatformsForStation<webApi.FragmentSocialUploadItemDto>(
      fragment.stationId,
      uploadsByPlatform,
    );
  const { hasAvailableSources } = useAvailableSocialExportSources({
    fragmentId: fragment.id,
    stationId: fragment.stationId,
  });
  const restrictionByPlatformId = usePublishRestrictions(availablePlatforms, { durationMs });

  const handlePlatformSelect = (platformId: string) => {
    const platform = availablePlatforms.find(
      (p: SocialPlatform) => p.id.toUpperCase() === platformId.toUpperCase(),
    );
    if (platform) {
      pushTo(routeGenerator.upload(fragment, platform));
    }
  };

  return (
    <SocialExportPublishPlatformDropdown
      platforms={availablePlatforms}
      disabled={!hasAvailableSources}
      restrictionByPlatformId={restrictionByPlatformId}
      onSelectPlatform={handlePlatformSelect}
    />
  );
}
